export * from './DetailsRehab.component';
